import { SxProps, Theme } from "@mui/material";

export const googleButton: SxProps<Theme> = {
    color: "black",
    borderColor: "black"
};